module.exports = __webpack_public_path__ + "img/job-3338103_1920.e4b47b29.jpg";